import React from 'react';

import { LoadableLazy } from '@confluence/loadable';
import { fg } from '@confluence/feature-gating';

import { useHasDismissedBulkActionsChangeboardingSpotlight } from './useHasDismissedBulkActionsChangeboardingSpotlight.tsx';

const BulkActionsChangeboardingSpotlightLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkActionsChangeboardingSpotlight" */ './BulkActionsChangeboardingSpotlightInner.tsx'
			)
		).BulkActionsChangeboardingSpotlightInner,
});

export const BulkActionsChangeboardingSpotlight = () => {
	const { isBulkActionsChangeboardingSpotlightDismissed } =
		useHasDismissedBulkActionsChangeboardingSpotlight();

	if (
		isBulkActionsChangeboardingSpotlightDismissed ||
		!fg('content_tree_with_bulk_actions_changeboarding')
	) {
		return null;
	}

	return <BulkActionsChangeboardingSpotlightLoader />;
};
